{
  "bookmarksMenu": "菜单",
  "change": "更改",
  "closeBookmarksMenu": "关闭菜单",
  "closeDialog": "关闭",
  "colonoscopy": "结肠镜检查 (colonoscopy)",
  "continue": "继续",
  "details": "详细信息",
  "errors": {
    "invalidOtp": {
      "details": "<ul>  \n<li>请检查是否有拼写错误，然后重试。</li>  \n<li>如果您遇到困难，请致电 {{phone}}（然后按选项 2）。</li>  \n</ul>",
      "title": "这与我们的记录不匹配"
    },
    "serverErrorOtp": {
      "details": "<ul>  \n<li>您的信息可能是正确的，但我们目前无法验证。</li>  \n<li>请稍等片刻后再试一次。</li>  \n</ul>",
      "title": "出现了一些问题。"
    }
  },
  "formattedDate": "{{date}} {{time}}",
  "gastroscopy": "胃镜检查 (gastroscopy)",
  "loading": "正在加载...",
  "next": "下一步",
  "no": "否",
  "openBookmarksMenu": "打开菜单",
  "optional": "可选",
  "progress": "进度 {{progress}}%",
  "selectLanguage": "选择语言",
  "step": {
    "appointment": "预约时间",
    "details": "个人信息",
    "health-questions": "健康问题",
    "history": "既往的手术或治疗",
    "insurance": "健康保险",
    "medications": "药物",
    "preference-questions": "偏好问题",
    "specialist": "专科医生"
  },
  "videoUnsupported": "您的浏览器不支持 video 标签。",
  "yes": "是",
  "yesTo": "是，选择",
  "yourProgress": "您的进度"
}
